/**
 * Copyright (c) Siemens 2016 - 2026
 * SPDX-License-Identifier: MIT
 */
import { ChangeDetectionStrategy, Component, ElementRef, input, viewChild } from '@angular/core';
import { SiIconComponent } from '@siemens/element-ng/icon';
import { SiTooltipService } from '@siemens/element-ng/tooltip';

import { SiHeaderActionIconItemBase } from './si-header-action-item-icon-base.directive';

/** Adds an action item to the header. Should be located inside `.header-actions`. */
@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'button[si-header-action-item], a[si-header-action-item]',
  imports: [SiIconComponent],
  templateUrl: './si-header-action-item.component.html',
  providers: [SiTooltipService],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'header-item focus-inside',
    '[class.dropdown-toggle]': '!!dropdownTrigger'
  }
})
export class SiHeaderActionItemComponent extends SiHeaderActionIconItemBase {
  /** The icon to be shown. */
  readonly icon = input.required<string>();

  protected readonly itemTitle = viewChild.required<ElementRef<HTMLElement>>('itemTitle');
}
